import React from "react";
import { styled } from "@mui/material";
import InstagramIcon from "@mui/icons-material/Instagram";
import IconAvatarStyled from "../IconAvatarStyled";

const InstagramIconStyled = styled(InstagramIcon)(({ theme }) => ({
  color: theme.palette.brand.instagram,
  fontSize: 24,
}));

export const InstagramIconAvatar: React.FC = () => (
  <IconAvatarStyled alt="Instagram Avatar">
    <InstagramIconStyled />
  </IconAvatarStyled>
);
